export default "__VITE_ASSET__BjRtqNlx__"